import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { giveawayApi } from 'src/api';

export const createGiveaway = createAsyncThunk(
  'giveaway/create-giveaway',
  async (data, thunkApi) => {
    try {
      const { payload, onCancel } = data;

      const response = await giveawayApi.createGiveaway(payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchGiveaways({}));

      if (onCancel) {
        onCancel();
      }

      return response.data;
    } catch (error) {
      console.error('createGiveaway[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const fetchGiveaways = createAsyncThunk(
  'giveaway/fetch-giveaways',
  async (data, thunkApi) => {
    try {
      const response = await giveawayApi.fetchGiveaways(data);

      return response.data;
    } catch (error) {
      console.error('fetchGiveaways[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const updateGiveaway = createAsyncThunk(
  'giveaway/update-giveaway',
  async (data, thunkApi) => {
    try {
      const { id, payload, onCancel } = data;

      const response = await giveawayApi.updateGiveaway(id, payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchGiveaways({}));

      if (onCancel) {
        onCancel();
      }

      return response.data;
    } catch (error) {
      console.error('updateGiveaway[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const fetchParticipiants = createAsyncThunk(
  'giveaway/fetch-participiants',
  async (data, thunkApi) => {
    try {
      const response = await giveawayApi.fetchParticipiants(data);

      return response.data;
    } catch (error) {
      console.error('fetchParticipiants[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const pickWinner = createAsyncThunk('giveaway/pick-winner', async (data, thunkApi) => {
  try {
    const response = await giveawayApi.pickWinner(data);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchGiveaways({}));

    thunkApi.dispatch(fetchParticipiants({ giveawayId: data?.giveawayId }));

    return response.data;
  } catch (error) {
    console.error('pickWinner[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});

export const rerollWinner = createAsyncThunk('giveaway/reroll-winner', async (data, thunkApi) => {
  try {
    const response = await giveawayApi.rerollWinner(data);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchGiveaways({}));

    thunkApi.dispatch(fetchParticipiants({ giveawayId: data?.giveawayId }));

    return response.data;
  } catch (error) {
    console.error('rerollWinner[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});
